import { createTypes } from 'redux-action-creator';

import { ActionWithPayload } from '../../../types';
import {
  WaiverWorkItem,
  WaiverWorkItemsListType,
} from '../../../../types/waiverWorkItem';

export const types: { [key: string]: string } = createTypes(
  ['LOAD', 'LOAD_SUCCESS'],
  'WORK_ITEM_SEARCH_RESULTS',
);

export function receiveResults(
  listType: WaiverWorkItemsListType,
  workItems: WaiverWorkItem[],
): ActionWithPayload<WaiverWorkItemsListType, number[]> {
  return {
    type: types.LOAD_SUCCESS,
    payload: listType,
    response: workItems.map(workItem => workItem.id),
  };
}
